import Badge from './Badge';

export default {
  id: 'radial_1',
  title: 'Radial_1',
  colors: 3,
  premium: true,
  BadgeComponentStateless: Badge
};
